module.exports = __webpack_public_path__ + "static/media/Join-Table-Purple.ae878de6.png";